import { Divider, Stack } from '@mui/material';

import { api } from 'common';

import { BlockDurationField } from '../../../ConfigFields/Duration';
import { FilterAndSortBlockFormFields } from '../FilterAndSortFormFields';

const PatientDataStore = api.FlowDefinition.PatientDataStore;

export const BookedAppointmentsVariant = {
  schema: PatientDataStore.BookedAppointmentsConfigSchema,
  Config: () => {
    return (
      <Stack spacing={2}>
        <BlockDurationField
          fieldName="config.bookedAppointmentFilters.after"
          valueLabel="Only fetch booked appointments after"
          unitFieldNameSuffix="units"
          allowedUnits={[...PatientDataStore.DURATION_UNIT_OPTIONS]}
        />

        <Divider sx={{ marginY: 2 }} />

        <FilterAndSortBlockFormFields />
      </Stack>
    );
  },
};
